export default "__VITE_ASSET__0jZ2XnPx__"